export default "__VITE_ASSET__ac05ce03__"